import * as Yup from "yup"
import _ from "lodash"

export default function validation_conditional_dropdown(field, acc) {
  const { field_name, field_validation } = field

  const conditions = JSON.parse(field.field_conditional)
  const fieldConditional = _.keys(conditions)
  const conditionFieldName = fieldConditional[0]

  const checkBool = () => {
    if (!field_validation.required) return false
    return field_validation.required[0] === "true"
  }

  const isRequired = checkBool()
  const isRequiredTxt = field_validation.required?.[1] || "Required field."

  const isForce = field_validation.force

  if (!isRequired) return acc

  if (isForce) {
    // Force branch: required, but no extra .nullable()
    return {
      [field_name]: Yup.string()
        .nullable()
        .when(conditionFieldName, (value, schema) => {
          const matches = _.isArray(value)
            ? _.some(value, (v) => _.includes(conditions[conditionFieldName], v))
            : _.includes(conditions[conditionFieldName], value)

          return matches
            ? schema.required(isRequiredTxt).nullable(false) // disallow null here
            : schema
        }),
      ...acc,
    }
  }

  // Default branch: required + nullable
  return {
    [field_name]: Yup.string()
      .nullable()
      .when(conditionFieldName, (value, schema) => {
        const matches = _.isArray(value)
          ? _.some(value, (v) => _.includes(conditions[conditionFieldName], v))
          : _.includes(conditions[conditionFieldName], value)

        return matches
          ? schema.required(isRequiredTxt).nullable() // allow null here
          : schema
      }),
    ...acc,
  }
}